(() => {
  // Native-pickup alternative: no cart picker. Checkout goes to plain /checkout and the
  // buyer picks Ship or Pick up there. Only the bfcache button reset is kept.
  if (window.sbfaFC) return;
  window.sbfaFC = { native: true };
  // Clear picker attributes left on carts from the picker version, so orders don't carry a stale choice.
  fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then((r) => r.json()).then((c) => {
    const a = (c && c.attributes) || {};
    if (a['Checkout-Method'] || a['Pickup-Location'] || a['Pickup-Location-Company']) {
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Checkout-Method': '', 'Pickup-Location': '', 'Pickup-Location-Company': '' } }) });
    }
  }).catch(() => {});

  // HAZ-40: Back from checkout can restore the page from bfcache with the checkout
  // button still showing 'Verifying items...' and disabled. Reset it.
  const BTN_SEL = '#checkout, #CartDrawer-Checkout';
  function rememberLabels() {
    document.querySelectorAll(BTN_SEL).forEach((b) => {
      if (!b.dataset.sbfaLabel && !/verifying/i.test(b.textContent)) b.dataset.sbfaLabel = b.textContent.trim();
    });
  }
  async function resetButtons() {
    rememberLabels();
    let count = null;
    try { count = (await (await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })).json()).item_count; } catch (e) {}
    document.querySelectorAll(BTN_SEL).forEach((b) => {
      if (/verifying/i.test(b.textContent) || b.dataset.sbfaLabel) {
        if (b.dataset.sbfaLabel) b.textContent = b.dataset.sbfaLabel;
        const expired = document.getElementById('expired-items-warning');
        const expiredShown = expired && expired.offsetParent !== null && /expired/i.test(expired.textContent) && expired.style.display !== 'none';
        if (count !== 0 && !expiredShown) b.removeAttribute('disabled');
      }
    });
  }
  window.addEventListener('pageshow', (ev) => { window.sbfaLastPageshowPersisted = !!ev.persisted; resetButtons(); });
  window.addEventListener('load', resetButtons);
  rememberLabels();
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', rememberLabels) : rememberLabels();
})();
